const company = (company = [], action) => {
  switch (action.type) {
    case 'FETCH_COMPANY_INFORMATION':
      return action.payload
    case 'UPDATE_COMPANY_INFORMATION':
      return {
        ...company,
        ...action.payload,
      }
    default:
      return company
  }
}

export default company
